@if (plans?.length) {
  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" class="text-center">Year</th>
        <th scope="col">Plan</th>
        <th scope="col" class="text-right">Init.</th>
        <th scope="col" class="text-right">Shr $</th>
        <th scope="col" class="text-right">Adj.</th>
        <th scope="col" class="text-right">Pur.</th>
        <th scope="col" class="text-right">Repur.</th>
        <th scope="col" class="text-right">Evrg</th>
        @if (canEdit) {
          <th scope="col">&nbsp;</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (plan of plans; track plan.id) {
        <tr>

          <td class="text-center">
            <span class="text-underline text-site-primary-alt pointable"
                  (click)="showPlan(plan)"
                  title="View {{plan.year}} Plan">
              {{plan.year}}
            </span>
          </td>
          <td>{{plan.info.typeDescription}}</td>
          <td class="text-right">{{plan.shareOffer}}</td>
          <td class="text-right">{{plan.sharePrice|currency:'USD':'symbol':'1.4-4'}}</td>
          <td class="text-right">{{plan.info.totalAdjustedShareOffer}}</td>
          <td class="text-right">{{plan.info.totalPurchasedShares}}</td>
          <td class="text-right">{{plan.info.totalRepurchasedShares}}</td>
          <td class="text-right">{{plan.info.totalEvergreenShares}}</td>
          @if (canEdit) {
            <td class="text-center">
              <button class="btn btn-sm btn-danger"
                      type="button"
                      (click)="deletePlan(plan)"
                      [disabled]="isDeleting"
                      title="Delete {{plan.year}} Plan">
                <i class="far fa-trash-alt"></i>
              </button>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}

@if (canEdit) {
  <div class="row mt-5">

    <div class="col text-center">

      <button class="btn btn-site-primary" (click)="showPlan()" type="button">
        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> Add New Plan
      </button>

    </div>

  </div>
}


<ng-template app-confirm-simple>
  <app-confirm-modal-component></app-confirm-modal-component>
</ng-template>

